import { format } from "date-fns";
import { addMinutes } from "date-fns";
import { subSeconds } from "date-fns";

import type { Entity } from "@/enums/entityProfiles";
import type {
  BaseProfileRelationship,
  BusinessProfileRelationship,
  IndividualProfileRelationship,
} from "@/models/entityProfiles";

/**
 * Returns a date-time string represented in UTC format.
 * @param {Date} date Optional date instance. Defaults to now.
 * @returns {string} The UTC date-time string
 */
export const getAsOfValue = (date: Date = new Date()): string => {
  let utcDateTime = addMinutes(date, date.getTimezoneOffset());
  // Subtracting 5 seconds from the value because
  // the API would throw a validation error sometimes
  // for as_of being in the future
  utcDateTime = subSeconds(utcDateTime, 5);
  return format(utcDateTime, "yyyy-MM-dd HH:mm:ss");
};

/**
 * Checks whether the entity profile is of the type specified.
 * Useful when transforming from BaseProfileRelationship to a specific Relationship type in the template.
 * @param {BaseProfileRelationship} profile The entity profile to check
 * @param {Entity} typeToAssert The entity type to assert
 */
export const profileIsOfType = <T extends Entity>(
  profile: BaseProfileRelationship | undefined,
  typeToAssert: T
): profile is T extends Entity.business
  ? BusinessProfileRelationship
  : IndividualProfileRelationship => {
  return !!profile && profile.type === typeToAssert;
};
